export default __webpack_public_path__ + "transfix-maps/icons/D4.5f73f01aad5c1f21d74d115734a5a061.png";